import {type AppState} from '../../types/app-state'

import {displayErrorMessage, getTheErrorCodes} from './helper'
import {
    type AssignVesselToTagReq,
    type CreateVesselTagReq,
    type UpdateVesselTagReq,
    type VesselTag,
} from '../../../api/vessels/types/vessel-tag'
import {type LocationTagArrayMapType} from './state'

export const vesselTagsSelector = (state: AppState): VesselTag[] => state.vesselTags.vesselTags

export const vesselTagsForLocationsSelector = (state: AppState): LocationTagArrayMapType =>
    state.vesselTags.tagsForLocation

export const isTheMessageErrorSelector = (state: AppState): boolean =>
    getTheErrorCodes(state.vesselTags.errorResult)

export const errorMessageSelector = (state: AppState): string =>
    displayErrorMessage(state.vesselTags.errorResult)

export const tagToCreateOrAssignSelector = (
    state: AppState,
): CreateVesselTagReq | AssignVesselToTagReq | null => state.vesselTags.tagToCreateOrAssign

export const tagToUpdateSelector = (state: AppState): UpdateVesselTagReq | null =>
    state.vesselTags.tagToUpdate

export const searchTermSelector = (state: AppState): string => state.vesselTags.searchedTerm

export const isTagLoadingSelector = (state: AppState): boolean => state.vesselTags.isFetchingTags
